export const DEFAULT_LANGUAGE = "it";
export const SUPPORTED_LANGUAGES = ["it", "en"];

export const translations = {
  it: {
    nav: {
      about: "About Me",
      timeline: "Timeline",
      projects: "Progetti",
      contact: "Contact Me"
    },
    hero: {
      subtitleLine1: "CREATIVE DEVELOPER",
      subtitleLine2: "3D & INTERACTIVE EXPERIENCES"
    },
    home: {
      about: {
        title: "About Me",
        paragraphs: [
          "La mia passione per la programmazione e' nata a 14 anni, iniziando con il design web e la creazione di siti semplici. Ho poi approfondito SQL, JavaScript e PHP.",
          "Durante gli anni scolastici ho imparato linguaggi come C++, C# e Java, sviluppando un metodo di problem solving e un approccio strutturato al ragionamento.",
          "Nell'ultima esperienza lavorativa ho esplorato il mondo del 3D e della realta virtuale usando Unity, Blender e Substance Painter. Questa esperienza ha arricchito la mia prospettiva, permettendomi di unire competenze tecniche e sensibilita' estetica per creare esperienze digitali coinvolgenti."
        ],
        focusLabel: "Focus Attuale"
      },
      timeline: {
        title: "Esperienze e Formazione",
        meta: "2017 - 2026 • Web • 3D • VR"
      },
      projects: {
        title: "Projects",
        viewProject: "View Project"
      },
      contact: {
        title: "Contact Me",
        paragraphs: [
          "Sono attualmente alla ricerca di nuove opportunita' nel web development, con particolare interesse per progetti che uniscano design, interazione e tecnologia.",
          "Se pensi che il mio profilo possa essere adatto al tuo team o a un progetto, saro' felice di parlarne."
        ],
        phoneLabel: "Cellulare",
        emailLabel: "E-mail",
        form: {
          nameLabel: "Name",
          namePlaceholder: "Your name",
          emailLabel: "Email",
          emailPlaceholder: "Your email",
          messageLabel: "Message",
          messagePlaceholder: "Tell me about your project",
          submit: "Send Message"
        }
      },
      backToTopAria: "Back to top"
    },
    footer: {
      role: "Creative Developer - Web & 3D",
      rights: "(c) 2026 - All rights reserved"
    },
    project: {
      notFound: "Project not found",
      backToTopAria: "Back to top",
      navigationTitle: "Projects",
      navigationSubtitle: "Seleziona un progetto"
    }
  },
  en: {
    nav: {
      about: "About Me",
      timeline: "Timeline",
      projects: "Projects",
      contact: "Contact Me"
    },
    hero: {
      subtitleLine1: "CREATIVE DEVELOPER",
      subtitleLine2: "3D & INTERACTIVE EXPERIENCES"
    },
    home: {
      about: {
        title: "About Me",
        paragraphs: [
          "My passion for programming started when I was 14, beginning with web design and basic websites. I then deepened my knowledge of SQL, JavaScript and PHP.",
          "During school years I learned languages such as C++, C# and Java, developing strong problem-solving skills and a structured approach to technical challenges.",
          "In my latest work experience I explored the world of 3D and virtual reality using Unity, Blender and Substance Painter. This helped me combine technical skills and visual sensitivity to build engaging digital experiences."
        ],
        focusLabel: "Current Focus"
      },
      timeline: {
        title: "Experience & Education",
        meta: "2017 - 2026 â€¢ Web â€¢ 3D â€¢ VR"
      },
      projects: {
        title: "Projects",
        viewProject: "View Project"
      },
      contact: {
        title: "Contact Me",
        paragraphs: [
          "I am currently looking for new opportunities in web development, with a strong interest in projects that combine design, interaction and technology.",
          "If you think my profile could fit your team or project, I would be glad to connect."
        ],
        phoneLabel: "Phone",
        emailLabel: "E-mail",
        form: {
          nameLabel: "Name",
          namePlaceholder: "Your name",
          emailLabel: "Email",
          emailPlaceholder: "Your email",
          messageLabel: "Message",
          messagePlaceholder: "Tell me about your project",
          submit: "Send Message"
        }
      },
      backToTopAria: "Back to top"
    },
    footer: {
      role: "Creative Developer - Web & 3D",
      rights: "(c) 2026 - All rights reserved"
    },
    project: {
      notFound: "Project not found",
      backToTopAria: "Back to top",
      navigationTitle: "Projects",
      navigationSubtitle: "Select a project"
    }
  }
};
